import { basicPlan, standardPlan, annualPlan } from '../../price-table/constants'

const isDowngrading = (subscription, upcomingSubscription) => {
  if (!subscription || !upcomingSubscription) return false

  // Order from lowest to highest
  const order = [basicPlan.sku, standardPlan.sku, annualPlan.sku]

  // Example: upcoming subscription is basic and current subscription is standard
  // Then it return 0 < 1 which is true
  return order.indexOf(upcomingSubscription.sku) < order.indexOf(subscription.sku)
}

export default isDowngrading
